import {
    Avatar,
    Box,
    Button,
    CircularProgress,
    Typography
} from "@mui/material"
import { LockOutlined } from "@mui/icons-material"
import { Form, Field } from 'react-final-form'
import { Input } from './components'
import {
    useLogin,
    useNotify,
    useSafeSetState,
    useTranslate
} from "react-admin"

export const LoginForm = () => {
    const [submitting, setSubmitting] = useSafeSetState(false)
    const translate = useTranslate()
    const login = useLogin()
    const notify = useNotify()

    const validate = (values) => {
        const errors = { username: undefined, password: undefined }
        if (!values.username) {
            errors.username = translate('ra.validation.required')
        }
        if (!values.password) {
            errors.password = translate('ra.validation.required')
        }

        return errors
    }
    const handleSubmit = (values) => {
        setSubmitting(true)
        login(values)
            .then(user => {
                setSubmitting(false)
                // localStorage.setItem('zWarehouseUser', JSON.stringify(user))
            })
            .catch(error => {
                setSubmitting(false)
                notify(
                    typeof error === 'string'  ? error :
                    typeof error === 'undefined' || !error.message
                    ? translate('ra.auth.sign_in_error')
                    : error.message)
            })
    }

    return (
        <Box sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        }}>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main'}}>
                <LockOutlined />
            </Avatar>
            <Typography component='h1' variant='h5'>
                School Start zWarehouse
            </Typography>

            <Form
                validate={validate}
                onSubmit={handleSubmit}
                render={({ handleSubmit }) => (
                    <Box component='form' onSubmit={handleSubmit} noValidate>
                        <Field
                            name='username'
                            label='Username'
                            // autoComplete='email'
                            component={Input}
                            disabled={submitting}
                            required={true} />

                        <Field
                            name='password'
                            label='Password'
                            type='password'
                            autoComplete='current-password'
                            component={Input}
                            disabled={submitting}
                            required={true} />

                        <Button
                            sx={{ mt: 3 }}
                            variant='contained'
                            type='submit'
                            disabled={submitting}
                            fullWidth>
                            {submitting &&
                                <CircularProgress
                                    sx={{ marginRight: 2 }}
                                    size={18}
                                    thickness={2} />
                            }
                            {translate("ra.auth.sign_in")}
                        </Button>  
                    </Box>
                )}
                />
        </Box>
    )
}